import React, { Component } from "react";
import {View, Image, TouchableOpacity, FlatList, Linking} from 'react-native'
import { icons } from "../theme/icons";
import { appStyles } from '../theme/styles'
import TextView from "../components/TextView";
import ReqeustItem from "../components/ReqeustItem";
import { ordersRequest } from "../utils/api";
import Waiting from "../components/Waiting";
export default class RequestListScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            waiting: false
        }
    }
    _keyExtractor = (item, index) => index.toString();
    renderRow({ item, index }) {
        return <ReqeustItem
            onRefresh={() => {
                this.getData()
            }}
            data={item}
            navigation={this.props.navigation} />
    }
    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>لیست درخواست ها</TextView>
                <TouchableOpacity onPress={() => {

                    if(this.props.navigation.canGoBack()) {
                        this.props.navigation.goBack()
                    }else {
                        Linking.openURL('/')
                    }


                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            {!this.state.waiting && this.state.data.length == 0 ? <TextView style={{ margin: 20, textAlign: 'center', color: 'gray' }}>تاکنون درخواستی ثبت نکرده اید</TextView> : null}
            <FlatList
                data={this.state.data}
                renderItem={this.renderRow.bind(this)}
                keyExtractor={this._keyExtractor} />
            <Waiting waiting={this.state.waiting} />
        </View>)
    }

    componentWillMount() {
        this.getData()
    }
    getData() {
        this.setState({
            waiting: true
        })
        ordersRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    data: response.data
                })
            }
        })
    }

}
